import { initLazyLoadedImages } from '../../src/listing_tile_rendering/listingImageRenderer'
import setUpAddToWishlistBehaviour from '../../src/addToWishlist'
import setUpSaveSearch from '../../src/saveSearch'
import initFiltersVisibilityToggle from '../../src/filtersVisibilityToggle'
import initColumnCountToggle from '../../src/searchResultsColumnCountToggle'
import setMaskedUrls from '../../src/maskedUrls'
import initStimulus from '../../src/controllers/plp'
import { initTradeTile } from '../../src/tradeChat'
import { recordSearch } from '../../src/recentSearchRecency'
import initVisualDiscoveryHowItWorks from '../../src/visualDiscoveryHowItWorks'

initStimulus()

document.addEventListener('DOMContentLoaded', () => {
  initLazyLoadedImages()
  setUpAddToWishlistBehaviour()
  setUpSaveSearch()
  setMaskedUrls()
  initTradeTile()
  initFiltersVisibilityToggle()
  initColumnCountToggle()
  recordSearch()
  initVisualDiscoveryHowItWorks()
})
